const TYPES = "HIMALAYAS_SPICE_CARD";
export const PARSE_FILE_AND_CREATE_SPICE_CARD = `${TYPES}/parse_file_and_create_spice_card`;
export const DELETE_SPICE_CARD = `${TYPES}/delete_spice_card`;
export const OPEN_SPICE_CARD_TEMPLATE_PAGE = `${TYPES}/open_spice_card_template_page`;
export const UPDATE_SPICE_CARD_INFO = `${TYPES}/update_spice_card_info`;
export const UPDATE_SPICE_CARD_DATA = `${TYPES}/update_spice_card_data`;
export const CLEAR_SPICE_CARD_INFO = `${TYPES}/clear_spice_card_info`;